var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplyNowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.82,
    height: 30.615,
    viewBox: "0 0 40.82 30.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hand-point-right-solid",
    d: "M38.269,66.551a2.551,2.551,0,1,1,0,5.1H21.686v-5.1ZM25.513,81.859a2.551,2.551,0,1,1,0,5.1h-5.1a2.551,2.551,0,1,1,0-5.1Zm5.1-5.1a2.549,2.549,0,0,1-2.551,2.551H24.237a2.551,2.551,0,1,1,0-5.1h3.827A2.549,2.549,0,0,1,30.615,76.756ZM22.961,89.513a2.551,2.551,0,1,1,0,5.1h-5.1a2.551,2.551,0,0,1,0-5.1Zm-7.016-7.654h.048a5.1,5.1,0,0,0,.175,5.39,5.1,5.1,0,0,0-3.412,4.816,5.025,5.025,0,0,0,.686,2.551h-.686A12.753,12.753,0,0,1,0,81.859V76.94a12.758,12.758,0,0,1,3.739-9.017L4.664,67a10.186,10.186,0,0,1,7.215-3h2.153a5.107,5.107,0,0,1,5.1,5.1v7.016a3.189,3.189,0,1,1-6.378,0V71.654a1.276,1.276,0,0,0-2.551,0v4.465A5.737,5.737,0,0,0,15.945,81.859Z",
    transform: "translate(0 -64)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyNowIcon);
export default __webpack_public_path__ + "static/media/apply-now-icon.6d40c0c6166f4d52e67d9dc7adefa3ae.svg";
export { ForwardRef as ReactComponent };